export const settingsTypes = {
  global: 'global',
  custom: 'custom',
}
